import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from 'react-redux';
import { store } from './store/store';
import {BrowserRouter} from 'react-router-dom';
import { applyTheme } from './utils/applyTheme';



const saved = localStorage.getItem("settings");
if (saved) {
  try {
    const parsed = JSON.parse(saved);
    applyTheme(parsed);
  } catch (e) {
    console.error("Failed to parse saved settings:", e);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

